<div class="activeViewPreview">
  @if (!ppHideText) {
    <span
      ppTooltip
      [ppTitle]="activeView?.name"
      [ppTrimTooltip]="true"
      class="activeViewPreview__name"
    >
      {{ activeView?.name }}
    </span>
  }

  @if (activeView) {
    <span class="savedViews__icon-container">
      <pp-icon
        ppTooltip
        [ppMobileTooltip]="true"
        [ppTitle]="ppHideText ? activeView?.name : null"
        [ppSVG]="iconMap[EIconPath.ICON_NAV_TABLE_VIEW_14]"
        ppColor="grey-400"
        [ppDisplayContents]="true"
        ppClass="setSize14"
      />
    </span>
  }
</div>
